<script lang="ts">
  import { AppState } from '../../etc/stores';
  export let size = 20;
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle
    cx="10"
    cy="10"
    r="10"
    fill={$AppState.theme.colors.illustration.secondary}
  />
  <path
    d="M14 7L8.5 13L6 10.2727"
    stroke="white"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
